var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { LetrwingCrypto } from '@@/LetrwingCommonCrypto';
import { Comparator, ConditionType, RuleType, SchemaItemType } from '@@/Schema';
import { action, makeObservable, observable } from 'mobx';
export class RuleParamUIConditionParam {
    constructor() {
        this.leftcondition = "";
        this.rightcondition = "";
        this.rightschemacol = "";
        this.comp = undefined;
        this.activeschemaite = undefined;
        makeObservable(this);
    }
    setRightSchemaCol(rsc) {
        this.rightschemacol = rsc;
    }
    setLeftCond(con) {
        this.leftcondition = con;
    }
    setRightCond(con) {
        this.rightcondition = con;
    }
    setComp(comp) {
        this.comp = comp;
    }
    getCompsFor(type) {
        if (type === undefined)
            return [];
        if (type === SchemaItemType.Boolean) {
            return [Comparator.Equal];
        }
        if (type === SchemaItemType.Choice) {
            return [Comparator.Equal, Comparator.Contains, Comparator.NotContains, Comparator.NotEqual];
        }
        if (type === SchemaItemType.Color) {
            return [Comparator.Equal];
        }
        if (type === SchemaItemType.Remote) {
            return [Comparator.Equal];
        }
        if (type === SchemaItemType.Date || type === SchemaItemType.Number) {
            return [Comparator.Equal, Comparator.Greater, Comparator.GreaterAndEqual, Comparator.Less, Comparator.LessAndEqual];
        }
        if (type === SchemaItemType.FormInput || type === SchemaItemType.Text) {
            return [Comparator.Equal, Comparator.Contains, Comparator.NotContains];
        }
        return [];
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], RuleParamUIConditionParam.prototype, "leftcondition", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RuleParamUIConditionParam.prototype, "rightcondition", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RuleParamUIConditionParam.prototype, "rightschemacol", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], RuleParamUIConditionParam.prototype, "comp", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RuleParamUIConditionParam.prototype, "setRightSchemaCol", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RuleParamUIConditionParam.prototype, "setLeftCond", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RuleParamUIConditionParam.prototype, "setRightCond", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RuleParamUIConditionParam.prototype, "setComp", null);
export class RuleParamUICondition {
    constructor() {
        this.conditionparam = [];
        this.condtype = ConditionType.And;
        this.prevresult = ConditionType.And;
        this.activenewparam = "schema";
        makeObservable(this);
    }
    setActiveNewParam(nty) {
        this.activenewparam = nty;
    }
    addCondParam(param) {
        this.conditionparam.push(param);
    }
    removeCondParam(index) {
        this.conditionparam.splice(index, 1);
    }
    setCondition(cond) {
        this.condtype = cond;
    }
    setPrevCond(cond) {
        this.prevresult = cond;
    }
}
__decorate([
    observable,
    __metadata("design:type", Array)
], RuleParamUICondition.prototype, "conditionparam", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], RuleParamUICondition.prototype, "condtype", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], RuleParamUICondition.prototype, "prevresult", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], RuleParamUICondition.prototype, "activenewparam", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RuleParamUICondition.prototype, "setActiveNewParam", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [RuleParamUIConditionParam]),
    __metadata("design:returntype", void 0)
], RuleParamUICondition.prototype, "addCondParam", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], RuleParamUICondition.prototype, "removeCondParam", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], RuleParamUICondition.prototype, "setCondition", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], RuleParamUICondition.prototype, "setPrevCond", null);
export class RuleParamUI {
    constructor() {
        this.typeunits = "days";
        this.type = "schema";
        this.value = "";
        this.conds = [];
        this.addmatchingcond = RuleType.Add;
        this.prevreusl = RuleType.Append;
        makeObservable(this);
    }
    setTypeUnits(units) {
        this.typeunits = units;
    }
    setPrevResultConnect(prevre) {
        this.prevreusl = prevre;
    }
    setActionForMatchingCond(action) {
        this.addmatchingcond = action;
    }
    addCondition(con) {
        this.conds.push(con);
    }
    removeCondition(index) {
        this.conds.splice(index, 1);
    }
    setType(type) {
        this.type = type;
    }
    setValue(value) {
        this.value = value;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], RuleParamUI.prototype, "typeunits", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], RuleParamUI.prototype, "type", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RuleParamUI.prototype, "value", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], RuleParamUI.prototype, "conds", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RuleParamUI.prototype, "addmatchingcond", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], RuleParamUI.prototype, "prevreusl", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RuleParamUI.prototype, "setTypeUnits", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RuleParamUI.prototype, "setPrevResultConnect", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RuleParamUI.prototype, "setActionForMatchingCond", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [RuleParamUICondition]),
    __metadata("design:returntype", void 0)
], RuleParamUI.prototype, "addCondition", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], RuleParamUI.prototype, "removeCondition", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RuleParamUI.prototype, "setType", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RuleParamUI.prototype, "setValue", null);
export class RuleUI {
    constructor(id) {
        this.id = "";
        this.type = RuleType.Add;
        this.params = [];
        this.prevstagerule = RuleType.Add;
        this.ruleconds = [];
        this.activerulecon = 'and';
        this.id = id;
        makeObservable(this);
    }
    setActiveRuleCon(con) {
        this.activerulecon = con;
    }
    addRuleCond(cond) {
        this.ruleconds.push(cond);
    }
    removeRuleCond(index) {
        this.ruleconds.splice(index, 1);
    }
    setType(type) {
        this.type = type;
        this.setPrevStageType(type);
    }
    setPrevStageType(type) {
        this.prevstagerule = type;
    }
    addRuleParam(irule) {
        this.params.push(irule);
    }
    removeRuleParam(index) {
        this.params.splice(index, 1);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], RuleUI.prototype, "id", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], RuleUI.prototype, "type", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], RuleUI.prototype, "params", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], RuleUI.prototype, "prevstagerule", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], RuleUI.prototype, "ruleconds", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RuleUI.prototype, "activerulecon", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RuleUI.prototype, "setActiveRuleCon", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [RuleParamUICondition]),
    __metadata("design:returntype", void 0)
], RuleUI.prototype, "addRuleCond", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], RuleUI.prototype, "removeRuleCond", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RuleUI.prototype, "setType", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RuleUI.prototype, "setPrevStageType", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [RuleParamUI]),
    __metadata("design:returntype", void 0)
], RuleUI.prototype, "addRuleParam", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], RuleUI.prototype, "removeRuleParam", null);
export class RuleBuilderStore {
    constructor() {
        this.show = false;
        this.zindex = 0;
        this.rulecoid = "";
        this.activeruleid = "";
        this.rules = [];
        this.activeruleindex = -1;
        this.activecontype = "schema";
        this.ruleByColumn = new Map();
        this.manualrulebyColumn = new Map();
        this.atciverule = undefined;
        this.saving = false;
        this.activeparam = "";
        this.activeparamui = undefined;
        this.activecondition = "and";
        this.activeparamitems = [];
        this.mnrule = false;
        this.precisionByColumn = new Map();
        makeObservable(this);
    }
    ;
    setActiveParamItems(items) {
        this.activeparamitems.splice(0, this.activeparamitems.length);
        this.activeparamitems.push(...items);
    }
    setActiveConditionType(type) {
        this.activecondition = type;
    }
    setActiveParam(id) {
        this.activeparam = id;
    }
    setSaving(sav) {
        this.saving = sav;
    }
    addRule(rule) {
        this.rules.push(rule);
    }
    setActiveConType(type) {
        this.activecontype = type;
    }
    setActiveRuleIndex(index) {
        this.activeruleindex = index;
    }
    deleteRule(id) {
        // lets remove this now!!
        for (let i = 0; i < this.rules.length; i++) {
            if (this.rules[i].id === id) {
                this.deleteRuleByIndex(i);
                break;
            }
        }
    }
    deleteRuleByIndex(index) {
        const delitems = this.rules.splice(index, 1);
        if (this.rulecoid !== '' && this.ruleByColumn.has(this.rulecoid) && this.rules.length === 0) {
            this.ruleByColumn.delete(this.rulecoid);
        }
        for (const di of delitems) {
            if (this.activeruleid === di.id) {
                this.setActiveRuleId("");
                this.setActiveRuleIndex(-1);
                this.atciverule = undefined;
            }
        }
    }
    setZIndex(index) {
        this.zindex = index;
    }
    setShow(show) {
        this.show = show;
    }
    setPrecsion(prec) {
        if (this.rulecoid === '')
            return;
        this.precisionByColumn.set(this.rulecoid, prec);
    }
    setRuleColId(id) {
        var _a;
        if (this.rulecoid === id)
            return;
        if (this.rulecoid !== '') {
            // lets just copy that edits now
            this.ruleByColumn.set(this.rulecoid, [...this.rules]);
            this.manualrulebyColumn.set(this.rulecoid, this.mnrule);
        }
        this.rulecoid = id;
        this.rules.splice(0, this.rules.length);
        const erules = this.ruleByColumn.get(id);
        if (erules) {
            this.rules.push(...erules);
        }
        this.setManualRule((_a = this.manualrulebyColumn.get(this.rulecoid)) !== null && _a !== void 0 ? _a : true);
        this.setActiveRuleId("");
        this.setActiveRuleIndex(-1);
        this.atciverule = undefined;
    }
    setManualRule(mn) {
        this.mnrule = mn;
    }
    setActiveRuleId(id) {
        this.activeruleid = id;
    }
    clearRulesForCol(id) {
        this.ruleByColumn.delete(id);
        if (this.rulecoid === id) {
            this.rules.splice(0, this.rules.length);
            this.activeruleid = "";
        }
    }
    convertRuleUIsToRules(manrules = new Map()) {
        var _a, _b;
        // this can be some deletion rule too ?
        if (this.rulecoid !== '' && this.rules.length > 0) {
            this.ruleByColumn.set(this.rulecoid, [...this.rules]);
        }
        const keys = Array.from(this.ruleByColumn.keys());
        const colrules = [];
        for (const key of keys) {
            const rules = this.ruleByColumn.get(key);
            if (rules && rules.length > 0) {
                const cr = this.convertRuleUiToRule(rules, key);
                cr.manualrule = (_a = manrules.get(key)) !== null && _a !== void 0 ? _a : false;
                cr.precision = (_b = this.precisionByColumn.get(key)) !== null && _b !== void 0 ? _b : '';
                colrules.push(cr);
            }
        }
        return colrules;
    }
    convertRulesToRuleUIParam(rules) {
        var _a, _b, _c;
        const ruleui = [];
        for (const r of rules) {
            const ru = new RuleUI(LetrwingCrypto.getUUID());
            ru.setType(r.type);
            ru.setPrevStageType((_a = r.prevstageresult) !== null && _a !== void 0 ? _a : r.type);
            if (r.conds) {
                for (const cc of r.conds) {
                    const cond = new RuleParamUICondition();
                    cond.setPrevCond(cc.prevtype);
                    cond.setCondition(cc.contype);
                    for (const ccp of cc.params) {
                        const ck = new RuleParamUIConditionParam();
                        ck.setComp(ccp.comp);
                        ck.setLeftCond(ccp.leftcond);
                        ck.setRightCond(ccp.rightcond);
                        ck.setRightSchemaCol(ccp.rightschemacon);
                        cond.addCondParam(ck);
                    }
                    ru.addRuleCond(cond);
                }
            }
            for (const rp of r.params) {
                const up = new RuleParamUI();
                if (rp.conds && rp.conds.length > 0) {
                    for (const cc of rp.conds) {
                        const cond = new RuleParamUICondition();
                        cond.setPrevCond(cc.prevtype);
                        cond.setCondition(cc.contype);
                        for (const ccp of cc.params) {
                            const ck = new RuleParamUIConditionParam();
                            ck.setComp(ccp.comp);
                            ck.setLeftCond(ccp.leftcond);
                            ck.setRightCond(ccp.rightcond);
                            ck.setRightSchemaCol(ccp.rightschemacon);
                            cond.addCondParam(ck);
                        }
                        up.addCondition(cond);
                    }
                }
                up.setActionForMatchingCond((_b = rp.matchingrow) !== null && _b !== void 0 ? _b : RuleType.Add);
                up.setType(rp.type);
                up.setValue(rp.value);
                up.setTypeUnits((_c = rp.typeunits) !== null && _c !== void 0 ? _c : 'days');
                ru.params.push(up);
            }
            ruleui.push(ru);
        }
        return ruleui;
    }
    reset() {
        this.ruleByColumn.clear();
        this.rulecoid = "";
        this.rules.splice(0, this.rules.length);
        this.activeruleid = "";
        this.activeruleindex = -1;
        this.atciverule = undefined;
        this.activecondition = "and";
        this.activecontype = "schema";
        this.activeparam = "";
        this.activeparamui = undefined;
        this.manualrulebyColumn.clear();
        this.precisionByColumn.clear();
        this.setManualRule(false);
    }
    setRules(rules) {
        var _a;
        this.reset();
        for (const rul of rules) {
            const cid = rul.colid;
            if (rul.precision) {
                this.precisionByColumn.set(rul.colid, rul.precision);
            }
            const uirules = this.convertRulesToRuleUIParam(rul.rule);
            this.ruleByColumn.set(cid, uirules);
            this.manualrulebyColumn.set(cid, (_a = rul.manualrule) !== null && _a !== void 0 ? _a : false);
        }
        if (rules.length > 0) {
            this.setRuleColId(rules[0].colid);
        }
    }
    convertRuleUiToRule(rui, id) {
        const srules = [];
        for (const r of rui) {
            const rconds = [];
            if (r.ruleconds) {
                if (r.ruleconds.length > 0) {
                    for (const rc of r.ruleconds) {
                        if (rc.conditionparam.length > 0) {
                            const rcp = [];
                            for (const rcpp of rc.conditionparam) {
                                if (rcpp.comp) {
                                    const pp = {
                                        leftcond: rcpp.leftcondition,
                                        comp: rcpp.comp,
                                        rightcond: rcpp.rightcondition,
                                        rightschemacon: rcpp.rightschemacol
                                    };
                                    rcp.push(pp);
                                }
                            }
                            if (rcp.length > 0) {
                                rconds.push({
                                    contype: rc.condtype,
                                    prevtype: rc.prevresult,
                                    params: rcp,
                                });
                            }
                        }
                    }
                }
            }
            const myparsm = [];
            for (const rp of r.params) {
                const conds = [];
                if (rp.conds.length > 0) {
                    for (const rc of rp.conds) {
                        if (rc.conditionparam.length > 0) {
                            const rcp = [];
                            for (const rcpp of rc.conditionparam) {
                                if (rcpp.comp) {
                                    const pp = {
                                        leftcond: rcpp.leftcondition,
                                        comp: rcpp.comp,
                                        rightcond: rcpp.rightcondition,
                                        rightschemacon: rcpp.rightschemacol
                                    };
                                    rcp.push(pp);
                                }
                            }
                            if (rcp.length > 0) {
                                conds.push({
                                    contype: rc.condtype,
                                    prevtype: rc.prevresult,
                                    params: rcp,
                                });
                            }
                        }
                    }
                }
                myparsm.push({
                    type: rp.type,
                    value: rp.value,
                    conds: conds,
                    matchingrow: rp.addmatchingcond
                });
            }
            const myrule = {
                type: r.type,
                params: myparsm,
                conds: rconds,
                prevstageresult: r.prevstagerule
            };
            srules.push(myrule);
        }
        const crule = {
            colid: id,
            rule: srules,
        };
        return crule;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], RuleBuilderStore.prototype, "show", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RuleBuilderStore.prototype, "zindex", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RuleBuilderStore.prototype, "rulecoid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RuleBuilderStore.prototype, "activeruleid", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], RuleBuilderStore.prototype, "rules", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RuleBuilderStore.prototype, "activeruleindex", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], RuleBuilderStore.prototype, "activecontype", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], RuleBuilderStore.prototype, "ruleByColumn", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], RuleBuilderStore.prototype, "manualrulebyColumn", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RuleBuilderStore.prototype, "saving", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RuleBuilderStore.prototype, "activeparam", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RuleBuilderStore.prototype, "activecondition", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], RuleBuilderStore.prototype, "activeparamitems", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RuleBuilderStore.prototype, "mnrule", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], RuleBuilderStore.prototype, "precisionByColumn", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], RuleBuilderStore.prototype, "setActiveParamItems", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RuleBuilderStore.prototype, "setActiveConditionType", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RuleBuilderStore.prototype, "setActiveParam", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], RuleBuilderStore.prototype, "setSaving", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [RuleUI]),
    __metadata("design:returntype", void 0)
], RuleBuilderStore.prototype, "addRule", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RuleBuilderStore.prototype, "setActiveConType", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], RuleBuilderStore.prototype, "setActiveRuleIndex", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RuleBuilderStore.prototype, "deleteRule", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], RuleBuilderStore.prototype, "deleteRuleByIndex", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], RuleBuilderStore.prototype, "setZIndex", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], RuleBuilderStore.prototype, "setShow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RuleBuilderStore.prototype, "setPrecsion", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RuleBuilderStore.prototype, "setRuleColId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], RuleBuilderStore.prototype, "setManualRule", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RuleBuilderStore.prototype, "setActiveRuleId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RuleBuilderStore.prototype, "clearRulesForCol", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Map]),
    __metadata("design:returntype", void 0)
], RuleBuilderStore.prototype, "convertRuleUIsToRules", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], RuleBuilderStore.prototype, "reset", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], RuleBuilderStore.prototype, "setRules", null);
